import {useQuery, useInfiniteQuery, useQueryClient, useMutation} from "react-query";
import {toast} from 'react-toastify';
import API from './utils/api';
import {
    PensionDto, 
    PensionPaginator,
    CreatePensionDto,
    UpdatePensionDto,
    SearchPensionDto,
    QueryPensionDto
} from "../models/pension.dto";
import ENDPOINTS from "./utils/endpoints";

export function useGetPension(options?: QueryPensionDto) {
    const url = ENDPOINTS.PROCESSING_COMPANY.PENSION.GET;
    const request = (options: QueryPensionDto) => API.ProcessingCompanyAPI.getPension(options);

    const { data, isLoading, error, refetch } = useQuery<PensionPaginator, Error>(
        [url, options],
        ({ queryKey, pageParam }) => request(Object.assign({}, queryKey[1], pageParam)),
        {...API.Handlers.pageParamOption}
    );

    return { data, isLoading, error, refetch }
}

export function useGetPensionById(id: number) {
    const url = ENDPOINTS.PROCESSING_COMPANY.PENSION.DETAIL;
    const request = API.ProcessingCompanyAPI.getPensionById(id);

    const {data, isLoading, error} = useQuery<{ data:PensionDto }, Error>(
        [url, id],
        (() => request),
        {
            enabled: !!(id),
        }
    );

    return {
        data: data,
        isLoading,
        error,
    };
}
export function useCreatePension() {
    const queryClient = useQueryClient();

    return useMutation(
        ({payload}: {payload: CreatePensionDto}) => API.ProcessingCompanyAPI.createPension(payload),
        {
            onSuccess: () => {
                toast.success('Record created successfully');
                queryClient.invalidateQueries(ENDPOINTS.PROCESSING_COMPANY.PENSION.GET);
            },
            onError: API.Handlers.onErrorHandler,
        }
    )
}

export function useUpdatePension() {
    const queryClient = useQueryClient();

    return useMutation(
        ({payload, id}: {payload: UpdatePensionDto, id: number}) => API.ProcessingCompanyAPI.updatePension(id, payload),
        {
            onSuccess: () => {
                toast.success('Record updated successfully');
                queryClient.invalidateQueries(ENDPOINTS.PROCESSING_COMPANY.PENSION.GET);
            },
            onError: API.Handlers.onErrorHandler,
        }
    )
}

export function useGetPensionSearch() {

    return useMutation(
        (options?: SearchPensionDto) => API.ProcessingCompanyAPI.getPensionSearch(options),
        {
            onSuccess: () => {
                //toast.success('Record created successfully');
            },
            onError: API.Handlers.onErrorHandler,
        },
    );
}

export function useDeletePension() {

    return useMutation(
        ({ id}: {id: number}) => API.ProcessingCompanyAPI.deletePension(id),
        {
            onSuccess: () => {
                toast.success('Record deleted successfully');
            },
            onError: API.Handlers.onErrorHandler,
        }
    )
}